import { forwardRef, type ComponentRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '~lib/utils/style';

const card = cva(
  'rounded-[1.25rem] bg-card p-8 text-card-foreground transition-colors duration-300',
  {
    variants: {
      ornament: {
        outline: 'border border-border',
        elevated: 'shadow-md',
      },
      interactive: {
        true: 'cursor-pointer hover:bg-card-highlight focus-visible:bg-card-highlight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        false: '',
      },
    },
    defaultVariants: {
      interactive: false,
    },
  },
);

interface CardProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof card> {
  as?: 'div' | 'article' | 'section' | 'figure' | 'a';
}

const Card = forwardRef<ComponentRef<'div'>, CardProps>(
  ({ as: Component = 'div', ornament, interactive, className, ...rest }, ref) => (
    <Component
      ref={ref as never}
      className={cn(card({ ornament, interactive }), className)}
      {...rest}
    />
  ),
);
Card.displayName = 'Card';

export { Card };
